"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CartContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reducers = _interopRequireDefault(require("./state/reducers"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/**
* cart state provider
*/
var CartContext = /*#__PURE__*/_react.default.createContext({
  context: {},
  setContext: function setContext() {}
});
exports.CartContext = CartContext;
var CartContextProvider = function CartContextProvider(_ref) {
  var children = _ref.children;
  /**
  * configure cart state
  */
  var initCartState = function initCartState(initailState) {
    return _objectSpread(_objectSpread({}, initailState), {}, {
      comment: ''
    });
  };
  /**
  * Initailize useReducer state/dispatch for cart component
  */
  var _ref2 = (0, _react.useReducer)(_reducers.default, {}, initCartState),
    _ref3 = _slicedToArray(_ref2, 2),
    cart = _ref3[0],
    dispatch = _ref3[1];
  /**
  * set dispatch action on the context provider
  */
  var _ref4 = (0, _react.useState)({
      cart: cart,
      dispatch: dispatch
    }),
    _ref5 = _slicedToArray(_ref4, 2),
    context = _ref5[0],
    setContext = _ref5[1];
  (0, _react.useEffect)(function () {
    setContext({
      cart: cart,
      dispatch: dispatch
    });
  }, [cart]);
  var cartContextHandler = function cartContextHandler(value) {
    setContext(value);
  };
  return /*#__PURE__*/_react.default.createElement(CartContext.Provider, {
    value: {
      context: context,
      setContext: cartContextHandler
    }
  }, children);
};
var _default = CartContextProvider;
exports.default = _default;